import React, { Component } from "react";
import {
  Button,
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
} from "react-bootstrap";
class DefaultView extends Component {
  state = {};
  render() {
    return (
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="#/dashboard">Dashboard</Navbar.Brand>
        <Navbar.Toggle aria-controls="admin-navbar" />
        <Navbar.Collapse id="admin-navbar">
          <Nav className="mr-auto">
            <Nav.Link href="#/dashboard">Dashboard</Nav.Link>
            <Nav.Link href="#link">Link</Nav.Link>
            <NavDropdown title="Startups" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Mentors" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Mentors 1</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">Mentors 2</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#link">Event Training</Nav.Link>
            <Nav.Link href="#link">Admin Panel</Nav.Link>
            <Nav.Link href="#link">Startup Reports</Nav.Link>
          </Nav>
          <Form inline>
            <FormControl type="text" placeholder="Search" className="mr-sm-2" />
            <Button variant="outline-success">Search</Button>
          </Form>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default DefaultView;
